// extracted by mini-css-extract-plugin
export var article = "home-module--article--LzKxP";
export var articleWrapper = "home-module--article-wrapper--uHDvD";
export var heroCopy = "home-module--hero-copy--Ajw--";
export var heroWrapper = "home-module--hero-wrapper--XWqLo";
export var quote = "home-module--quote--8agbp";
export var quoteImage = "home-module--quote-image--j8clt";
export var quoteWrapper = "home-module--quote-wrapper--dsiAG";